<input
    #elementRef
    [attr.type]="inputType$ | async"
    [formControl]="control"
    [id]="id"
    class="sh-input-field sh-form-group__input"
    [attr.min]="min || null"
    [attr.max]="max || null"
    [attr.autocomplete]="autocomplete || null"
    [attr.placeholder]="message$ | async"
    [attr.aria-describedBy]="invalid ? describeLabelId : null"
    [attr.aria-invalid]="invalid"
    [attr.disabled]="disabled ? true : null"
    (focus)="focusChange($event)"
    (blur)="focusChange($event)"
    (keyup)="keyboardChange($event)"
/>
